import _ from 'lodash'

import { InterviewOffersQuery } from '@/graphql-schema'
import { IsErrorHandlingMutation } from '@/utils'

import { fromPromise } from 'apollo-link'
import { stat } from 'fs'
import { Mutation as VuexMutation, MutationTree } from 'vuex'
import { ModuleState, Offer } from './types'

export interface AddMutation {
  type: 'add' | 'interview/offers/add'
  offer: Offer
}

export interface UpdateMutation {
  type: 'update' | 'interview/offers/update'
  offer: Offer
}

export interface SelectToEditMutation {
  type: 'selectToEdit' | 'interview/offers/selectToEdit'
  offer: Offer
  withIntent: 'reschedule'
}

export interface StopToEditMutation {
  type: 'stopToEdit' | 'interview/offers/stopToEdit'
}

export interface SortMutation {
  type: 'sort' | 'interview/offers/sort'
}

export interface UpdateAllMutation {
  type: 'updateAll' | 'interview/offers/updateAll'
  offers: InterviewOffersQuery['offers']
}

export interface ResetAllMutation {
  type: 'resetAll' | 'interview/offers/resetAll'
}

export interface CatchErrorMutation extends IsErrorHandlingMutation {
  type: 'catchError' | 'interview/offers/catchError'
}

export interface ClearErrorMutation extends IsErrorHandlingMutation {
  type: 'clearError' | 'interview/offers/clearError'
}

export type Mutation =
  | AddMutation
  | CatchErrorMutation
  | ClearErrorMutation
  | ResetAllMutation
  | SelectToEditMutation
  | SortMutation
  | StopToEditMutation
  | UpdateAllMutation
  | UpdateMutation

export const add: VuexMutation<ModuleState> = (state, { offer }: AddMutation) => {
  state.offers.push(offer)
}

export const catchError: VuexMutation<ModuleState> = (
  state,
  { error }: CatchErrorMutation
) => {
  console.error('uncaught error in vuex module interview/offers')
  console.error(error)
  state.uncaughtErrors.push(error)
}

export const clearError: VuexMutation<ModuleState> = (
  state,
  { error }: ClearErrorMutation
) => {
  const index = state.uncaughtErrors.findIndex(e => e === error)
  if (index > -1) {
    state.uncaughtErrors.splice(index, 1)
  }
}

export const update: VuexMutation<ModuleState> = (
  state,
  { offer }: UpdateMutation
) => {
  const index = _.findIndex(state.offers, { id: offer!.id })
  const newIndex = _.sortedIndexBy(state.offers, offer, 'timeSlot.start.value')
  if (index > -1) {
    state.offers.splice(index, 1)
  }
  state.offers.splice(newIndex, 0, offer)
}

export const selectToEdit: VuexMutation<ModuleState> = (
  state,
  { offer, withIntent }: SelectToEditMutation
) => {
  state.editOffer = {
    editObject: offer,
    withIntent,
  }
}

export const stopToEdit: VuexMutation<ModuleState> = state => {
  state.editOffer = null
}

export const updateAll: VuexMutation<ModuleState> = (
  state: ModuleState,
  { offers: offer }: UpdateAllMutation
) => {
  state.offers = offer!.nodes
}

export const resetAll: VuexMutation<ModuleState> = state => {
  if (state.subscription && !state.subscription.closed) {
    state.subscription.unsubscribe()
  }
  state.offers = []
  state.editOffer = null
  state.now = new Date()
  state.uncaughtErrors = []
}

export const mutations: MutationTree<ModuleState> = {
  add,
  catchError,
  clearError,
  resetAll,
  selectToEdit,
  stopToEdit,
  update,
  updateAll,
}

export default mutations
